import { render, staticRenderFns } from "./UploadMediaCenter.vue?vue&type=template&id=3516abdb&scoped=true"
import script from "./UploadMediaCenter.vue?vue&type=script&lang=js"
export * from "./UploadMediaCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516abdb",
  null
  
)

export default component.exports